const reducer = (state = {}, action) =>{
    switch(action.type){
        case "setCompanyInfo": 
            return action.payload;
        default: 
            return state;
    }
}

export default reducer;  